import { useGetCodespacesQuery } from 'Services/ControlDataManagement/Features/Codespace/codespaceApi'
import type { FetchCodespaceListParams } from 'Services/ControlDataManagement/Features/Codespace/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_CODESPACE_PARAMETER_KEY = 'selectedCodespace'

function useCodespacesWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchCodespaceListParams>({
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: codespaces } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching,
    refetch
  } = useGetCodespacesQuery(params)

  const selectedCodespaceQueryParam =
    searchParams.get(SELECTED_CODESPACE_PARAMETER_KEY) ?? undefined
  const [selectedCodespaceId, setSelectedCodespaceId] = useState(selectedCodespaceQueryParam)

  const setQueryParams = () => {
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    }

    selectedCodespaceId && searchParams.set(SELECTED_CODESPACE_PARAMETER_KEY, selectedCodespaceId)
    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedCodespaceId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_CODESPACE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedCodespaceId])

  return {
    codespaces,
    isFetching,
    fetchCodespaces: refetch,
    totalResults,
    params,
    setParams,
    setSelectedCodespaceId,
    selectedCodespaceId
  }
}

export default useCodespacesWithParams
